<template>
	<div>
		<a-modal v-show='!ishand' id='tkuanzs' width='33rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">提款指示</div>

			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="border-radius: 0 0 10px 10px;">
				<div style="padding-top: 1.3rem;width: 91%;">
					<a-form-model ref='isForm' :model="form" labelAlign='right' layout="inline" hideRequiredMark>
						<a-row type="flex" justify="space-between">
							<a-col :span='3'>
								<a-form-model-item label='' porp='currency'>
									<a-select v-model="form.currency" class='warp_width' style='width: 5rem;'>
										<a-select-option v-for="(item) in columnsData" :key="item.key+'a'"
											:value="item.ccy">{{item.ccy}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :span='6'>
								<div>
									<a-form-model-item label='' porp='price'>
										<a-input v-model="form.price" class='warp_width' placeholder="" @input='funfn'
											style='width: 10.5rem;' />
									</a-form-model-item>
								</div>
							</a-col>
							<a-col :span='3'>
								<button class='btn1 btnx' @click='maxfn'>MAX</button>
							</a-col>
							<a-col :span='3'>
								<div style="position: relative;left: -.5rem;">
									<button class='btn1 btnxr' @click='btn(1)'>確定</button>
								</div>
							</a-col>
						</a-row>
						<!-- <a-form-model-item label='備註'  porp='remark'>
							<a-textarea v-model="form.remark" class='warp_width'
							 :autoSize="{minRows: 4, maxRows: 10}"
							 placeholder="請輸入聯絡電話於此備註欄" style='width: 21.5rem;'/>
						</a-form-model-item>
						<p style="color: #000000;">
							銀行收取的跨行轉帳及電匯費用將由客戶支付並從提款金額中扣除。
							提款指示截止時間為交易日中午12時，截止時間後收到的指示將延至
							下一個交易日處理
						</p> -->
					</a-form-model>
				</div>
				<div>
					<!-- <div style="text-align: center;">
						<button class='btn1 btnx' @click='btn(0)'>提走所有</button>
					</div> -->
					<!-- <div style="text-align: center;color: #2a83dd;margin: 2rem 0 1rem;font-size: .9rem;">隱藏 現金結餘 及 提款/存款紀錄</div> -->
					<div
						style="text-align: center;color: #fff;background-color: #0C8B96;font-size: .8rem;padding: .2rem 0;">
						現金結餘</div>
					<a-table style="width:100%;" :columns="column" :data-source="columnsData" id='fromtable1'
						:pagination="false" size="small">
						<div slot='surplusnum' slot-scope="record" style="white-space: nowrap;" >
							<div v-if='record.surplus>0' >{{record.surplusnum}}</div>
							<div v-else style='color:red;'>{{record.surplusnum}}</div>
						</div>
						<div slot='amt' slot-scope="record" style="white-space: nowrap;" >
							<div v-if='record.states' >{{record.amt}}</div>
							<div v-else style='color:red;'>{{record.amt}}</div>
						</div>
					</a-table>
				</div>
				<div style="padding-top: 1.5rem;">
					<div
						style="text-align: center;color: #fff;background-color: #0C8B96;font-size: .8rem;padding: .2rem 0;">
						提存款記錄</div>
					<a-table style="width:100%;" :columns="columns" :data-source="columnsDatas" id='fromtable1'
						:pagination="false" size="small"  :scroll="{y: 150 }">
						<div slot='price' slot-scope="record" style="white-space: nowrap;" >
							<div v-if='record.states' >{{record.price}}</div>
							<div v-else style='color:red;'>{{record.price}}</div>
						</div>
					</a-table>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';

	export default {
		props: ['openstatic'],
		data() {
			return {
				columnsData: [{
					a: 'USD',
					b: '-1099,758'
				}, {
					a: 'USD',
					b: '0'
				}, {
					a: 'USD',
					b: '0'
				}],
				columnsDatas:[],
				column: [{
					title: '貨幣',
					dataIndex: 'ccy',
					align: 'center',
					width: '33%',
				}, {
					title: '結餘',
					dataIndex: '',
					align: 'center',
					width: '33%',
					scopedSlots: {
						customRender: 'amt'
					},
				}, , {
					title: '最高提款金額',
					dataIndex: 'surplusnum',
					align: 'center',
					width: 'auto',
				}, ],
				columns: [{
					title: '貨幣',
					dataIndex: 'ccy',
					align: 'center',
					width: '33%',
				}, {
					title: '金額',
					dataIndex: '',
					align: 'center',
					width: '33%',
					scopedSlots: {
						customRender: 'price'
					},
				}, , {
					title: '時間',
					dataIndex: 'createtime',
					align: 'center',
					width: 'auto',
				}, ],
				england: 'cn',
				visible: true,
				ishand: false,
				form: {
					token: "daca4cca-f334-4c26-8165-3f8d583e17fe",
					username: 1000005,
					"usercode": "1111696",
					"currency": "HKD",
					"price": "",
					"remark": "",
					"flag": "1"
				},
				currency1: '',
				admintypeArr: [{
					text: 'HKD',
					value: '1'
				}, {
					text: 'SGD',
					value: '1'
				}, {
					text: 'USD',
					value: '1'
				}, ],
			}
		},
		mounted() {
			this.postdata()
		},
		methods: {
			maxfn(){
				let s ;
				this.columnsData.map(ev=>{
					if(this.form.currency ==ev.ccy){
						s = ev.surplus
					}
				})
				this.form.price=s
			},
			funfn() {
				if(isNaN(Number(this.form.price))){
					this.form.price = ''
					return
				}
				let s ;
				this.columnsData.map(ev=>{
					if(this.form.currency ==ev.ccy){
						s = ev.surplus
					}
				})
				if(this.form.price>s)
				{
					this.form.price=s
				}
			},
			btn(ev) {
				if (!this.form.price) {
					App.oTool.warningT('金额不能为空');
					return
				}
				
				this.$ajax({
					method: 'post',
					url: this.$api.newDiscounting,
					data: {
						"token": this.$store.state.token,
						"tc_flag":"T",  // T 提款 C 存款
						 "ccy":this.form.currency,  //貨幣
						 "price":this.form.price    //金額
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
					App.oTool.successT();
					this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})

			},
	
			fanjiebao(val, to = 2, num = 1) {
				//金额转换 分->元 保留2位小数 并每隔3位用逗号分开 1,234.56
				var str = (val / num).toFixed(to) + '';
				var intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ','); //取到整数部分
				var dot = str.substring(str.length, str.indexOf(".")) //取到小数部分搜索
				var ret = intSum + dot;
				return ret;
				//输出结果->20,000.00
			},
			postdata() {
				this.$ajax({
					method: 'post',
					url: this.$api.getDiscountingLog,
					data: {
						"token": this.$store.state.token,
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.cash_pos
						this.columnsDatas = res.data.discountingLog
						this.columnsData.map(ev=>{
							ev['states'] = ev.amt>=0
							ev.amt = this.fanjiebao(ev.amt,2)
							ev['surplusnum'] = this.fanjiebao(ev.surplus,2)
						})
						this.columnsDatas.map(ev=>{
							ev['states'] = ev.price>=0
							ev.price = this.fanjiebao(ev.price,2)
							ev['surplusnum'] = this.fanjiebao(ev.surplus,2)
						})
					} else {
						// App.oTool.warningT(res.data.qmismsg);
					}

				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>
<style lang='scss' scoped>
	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.btn1 {
		width: 5rem;
		height: 1.6rem;
		font-size: .8rem;
		border: 0;
		border-radius: 5px;
		margin: .2rem 1.5rem;
	}

	.btnxr {
		color: #ffbe83;
		background-color: #fff;
		border: 1px solid #ffbe83;
	}

	.btnx {
		color: #fff;
		background-color: #2a83dd;
	}
</style>
<style lang="scss">
	#tkuanzs {
		.ant-modal-header,
		.ant-modal-body {
			background-color: #fff !important;
		}
		.ant-modal {
			top: 18vh;
		}

		.ant-modal-close-x {
			.anticon svg{
			color: #5cb1b9 !important;
			position: relative;
			top: .8rem;
			right: 0;
			}
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: 1rem !important;
		}

		.ant-input {
			font-size: 1rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: 1rem !important;
		}

		.ant-form-item-children {
			font-size: 1rem !important;
		}

		.ant-modal-body {
			// padding: 0;
			padding-top: 2.5rem;
		}

		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
